import { Routes, Route } from 'react-router-dom';
import { CardapioPage } from './components/CardapioPage';
import { LandingState } from './components/LandingState';
import { MesaPage } from './components/mesa/MesaPage';

// Roteamento por SLUG. O cardápio de um tenant vive em /:slug
// (ex.: cardapio.vittogestao.com.br/vitamunhoz). A raiz "/" e qualquer rota
// desconhecida caem numa página amigável de orientação.
export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingState />} />
      <Route path="/mesa/:codigoPublico" element={<MesaPage />} />
      <Route path="/:slug" element={<CardapioPage />} />
      <Route path="*" element={<LandingState />} />
    </Routes>
  );
}
